import { UsePopup } from "@/components/root/popup/popup.state";
import { remToPx } from "../dom.functions";
import { EventBusListenerArgs } from "./model";
import Confidence from "@/components/Confidence.vue";

export const bus_confidence_listener = (): EventBusListenerArgs => [
  "confidence-popup",
  async (payload: { source: any; event: MouseEvent }) => {
    const { labels, showConfidence } = payload.source;

    if (showConfidence) {
      const res = await UsePopup.showActionPopup({
        type: "CustomDisplayPopup",
        cmp: Confidence,
        items: labels,
        event: payload.event,
        position: "top",
        width: remToPx(30),
      });
      if (res.type === "success") {
        // TODO: send to server for the given file/clusterUID and save local changes.
      }
    } else {
      UsePopup.showDisplayPopup({
        type: "TextDisplayPopup",
        items: [
          "The confidence is only calculated for files <br> mapped after June 2, 2021",
        ],
        event: payload.event,
        position: "top",
        width: remToPx(25),
      });
    }
  },
];
